export default __webpack_public_path__ + "static/media/2R.2b705433.svg";